var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3929 8.70982C0.498729 5.91816 1.54373 2.72732 4.47456 1.78316C6.01623 1.28566 7.7179 1.57899 8.99956 2.54316C10.2121 1.60566 11.9762 1.28899 13.5162 1.78316C16.4471 2.72732 17.4987 5.91816 16.6054 8.70982C15.2137 13.1348 8.99956 16.5432 8.99956 16.5432C8.99956 16.5432 2.83123 13.1865 1.3929 8.70982Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M12.333 4.6279C13.2247 4.91623 13.8547 5.71207 13.9305 6.64623",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.7a8498db068571c3bb3384ded961bf4e.svg";
export { ForwardRef as ReactComponent };